import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, QueryList, ViewChildren, Input, Renderer2, ChangeDetectorRef } from '@angular/core';
import { CustomIconService } from 'src/app/core/services/custom-icon.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../../core/services/user.service';
import * as moment from 'moment';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ServicesService } from '../../../services/services.service';
import { ServicesLogosService } from '../../../../core/services/services-logos.service';
import { interval, Observable, shareReplay, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LoadingService } from 'src/app/core/components/loading/loading.service';
import { Title } from '@angular/platform-browser';
import { FlowAuthorizationSchemeModalComponent } from './components/modals/flow-authorization-scheme-modal/flow-authorization-scheme-modal.component';
import { FlowChangeNameModalComponent } from './components/modals/flow-change-name/flow-change-name-modal.component';
import { FlowPublishModal } from './components/modals/flow-publish/flow-publish-modal.component';
import { FlowValidateModalComponent } from './components/modals/flow-validate/flow-validate-modal.component';
import { FlowValidatingModalComponent } from './components/modals/flow-validation/flow-validation-modal.component';
import { FlowConfirmEditModal } from './components/modals/flow-confirm-edit/flow-confirm-edit-modal.component';
import { UrlService } from '../../../../core/services/url.service';
import { MatDialog } from '@angular/material/dialog';
import { Params } from 'src/app/contexts/transactions/pages/list/models/params.model';
import { CreateAbTestComponent } from '../create-ab-test/create-ab-test.component';
import { FlowsService } from '../../flows.service';
import { AuthorizationSchemeService } from '../../authorization_scheme.service';
import { PeriodModalComponent } from '../snapshot/modals/period/period-modal.component';
import * as antifraud_actions_config from './json/antifraud-action-config.json';
import { AuthorizationEditComponent } from 'src/app/contexts/authorizations/edit/authorization-edit/authorization-edit.component';

@Component({
  selector: 'app-flow',
  templateUrl: './flow.component.html',
  styleUrls: ['../snapshot/components/flows-status/flows-status.component.scss',
    '../snapshot/components/flows-status/flows-status-responsive.component.scss',
    './flow.component.scss', './flow-header.component.scss', './flow-responsive.component.scss']
})
export class FlowComponent implements OnInit, AfterViewInit {

  model: any = {
    themes: {
      light: 'light',
      dark: 'dark',
    },
    darkClass: 'theme-dark',
  };
  error = false;
  menuEnd = '';
  expandedStepState: boolean = true;
  subscription: Subscription;
  onlyViewer = false;
  saving: boolean = false;
  form: FormGroup;
  can_edit = false;
  firstOpen = true;
  previousUrl;
  chart$: Observable<any>;
  params: Params;
  permission: any = {};
  loadedFlow = false;
  metrics$: Observable<any>;

  antifraud_actions_config: any = (antifraud_actions_config as any).default.antifraud_actions_config;

  @ViewChild('header') header: ElementRef;
  @ViewChildren('iconFlow') iconFlow: QueryList<ElementRef>;
  @Input() iconFlowTop = '0';

  formatter(value: number): string {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }

  constructor(
    private customIconService: CustomIconService,
    public router: Router,
    private route: ActivatedRoute,
    public elementRef: ElementRef,
    private dialog: MatDialog,
    private userService: UserService,
    private ServicesLogosService: ServicesLogosService,
    private serviceService: ServicesService,
    private flowsService: FlowsService,
    public renderer: Renderer2,
    public translateService: TranslateService,
    private authorizationSchemeService: AuthorizationSchemeService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private fb: FormBuilder,
    private loadingService: LoadingService,
    private titleService: Title,
    private flowService: FlowsService,
    private cdr: ChangeDetectorRef,
    private urlService: UrlService
  ) { }


  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  ngOnInit(): void {

    this.customIconService.init();

    this.route.queryParamMap.subscribe(params => {
      this.params = new Params(params);
    });

    this.urlService.previousUrl$.subscribe((previousUrl: string) => {
      this.previousUrl = previousUrl?.split('/');
    });

    this.form = this.fb.group({});

    this.model.user = this.userService.getUser();
    var features = this.model.user.features.find(p => p.key == 'snapshot');

    this.route.params.subscribe(params => {

      if (params) {
        const { partner, account, snapshot_id, selector_test_id, flow_id, version, order, orders, start, end } = params;
        this.model = {
          ...this.model,
          partner,
          account,
          snapshot_id,
          selector_test_id,
          flow_id,
          version,
          order,
          orders,
          index_ab: orders.indexOf(order),
          is_ab: orders.split(",").length > 1,
          period: {
            start: start ? moment(start) : null,
            end: moment(end || moment().format('YYYY-MM-DD')),
          }
        };

        const { subfeatures } = features || {};
        const hasSubfeatures = (key) => subfeatures?.some(p => p.key === key && p.enabled);

        this.permission = {
          create: hasSubfeatures('snapshot,create') || this.model.user.isUserTuna,
          edit: hasSubfeatures('snapshot,edit') || this.model.user.isUserTuna,
          publish: hasSubfeatures('snapshot,publish') || this.model.user.isUserTuna,
        };
      }
    });

    this.route.paramMap.subscribe(params => {

      const keys = ['partner', 'account', 'snapshot_id', 'selector_test_id', 'flow_id', 'version', 'order', 'orders'];
      keys.forEach(key => {
        this.model[key] = params.get(key);
      }); // GET PARAMS URL

      this.model.index_ab = this.model.orders.split(',').indexOf(this.model.order);

      this.model.period = {
        start: params.get('start') ? moment(params.get('start')) : null,
        end: moment(
          params.get('end') ? params.get('end') : moment().format('YYYY-MM-DD')
        ),
      };

    });

    this.route.data.subscribe(
      (response) => {

        var totalSelectorTestFlow = [...response.flows.flows.selector_test_list.selector_test_flows];
        totalSelectorTestFlow.sort((a, b) => a.order - b.order);
        var lastFlow = totalSelectorTestFlow[totalSelectorTestFlow.length - 1];

        if (lastFlow.status == 0) {
          this.model.canCancelTestAB = false;
        } else {
          this.model.canCancelTestAB = true;
        }

        this.model.custom_services = [
          {
            id: 'action_wait_any_antifraud',
            name: this.translateService.instant('flows.detail.action_wait_any_antifraud')
          },
          {
            id: 'action_wait_any_approved_antifraud',
            name: this.translateService.instant('flows.detail.action_wait_any_approved_antifraud')
          },
          {
            id: 'action_accumulate',
            name: this.translateService.instant('flows.detail.action_accumulate')
          },
          {
            id: 'action',
            name: this.translateService.instant('flows.detail.custom_action_title')
          }
        ];

        // Remove "action_accumulate" se o usuário for "angeloni"
        if (this.model.user.realm === 'angeloni') {
          this.model.custom_services = this.model.custom_services.filter(service => service.id !== 'action_accumulate');
        }


        this.model.filter_antifrauds = response.flows.variables.filter_antifrauds.options;

        this.model.filter_3ds = response.flows.variables_3ds.filter_antifrauds.options;

        this.model.operations = response.flows.variables.language.operations;
        const actionIds = [
          'action_wait_any_antifraud',
          'action_wait_any_approved_antifraud',
          'action_accumulate',
          'action'
        ];

        this.model.custom_services = actionIds.map(id => ({
          id,
          name: id == 'action' ? this.translateService.instant(`flows.detail.add_action`) : this.translateService.instant(`flows.detail.${id}`)
        }));

        const flows = response.flows;
        const flowVersion = flows.flows.flow_version;
        const selectorTestList = flows.flows.selector_test_list;

        selectorTestList.selector_test_flows = response.flows.flows.selector_test_list.selector_test_flows.filter(p => this.model.orders.split(",").find(x => x == p.order)); // somente os selectors_tests_flows que tem nas ordem

        this.model.services = flows.fraud_verication.services.filter(service => service.active);
        this.model.threeds = flows.threeds.services.filter(service => service.active);

        this.model = {
          ...this.model,
          filter_antifrauds: flows.variables.filter_antifrauds.options,
          filter_3ds: flows.variables_3ds.filter_antifrauds.options,
          operations: flows.variables.language.operations,
          terms: flows.variables.language.terms.filter(term => !term.hidden),
          flow_version: {
            ...flowVersion,
            flow_orders: this.getService(flowVersion.flow_orders || []),
            authorization_scheme: flowVersion.authorization_scheme
          },
          authorization_schemes: flows.authorization_schemes.authorization_schemes,
          selector_test_flow: selectorTestList.selector_test_flows.find(
            testFlow =>
              testFlow.flow_id == this.model.flow_id &&
              testFlow.version == this.model.version &&
              testFlow.order == this.model.order
          )
        };

        this.model.authorization_schemes = response.flows.authorization_schemes.authorization_schemes;

        this.checkASDropped();

        this.containsServiceTuna();

        this.model.selector_test = response.flows.flows.selector_test_list;

        this.getMetrics();

        if (this.model.selector_test) {
          if (this.model.selector_test.start_date) {
            var start = moment();
            var end = moment(this.model.selector_test.start_date);
            this.model.selector_test.days_running = moment.duration(start.diff(end)).asDays().toFixed(0);
          }
        }

        var as = this.model.flow_version.flow_orders?.find(p => p.type.toLowerCase() == 'authorize');
        if (as)
          this.model.flow_version.flow_orders.find(p => p.type.toLowerCase() == 'authorize').id = this.model.flow_version.authorization_scheme?.id;

        if (!this.model.flow_version.filters || this.model.flow_version.filters.length === 0) {
          const obj = this.model.flow_version.is_default
            ? this.addFilterFlowDefault()
            : {
              name: this.translateService.instant('flows.detail.filter_name'),
              expression: {
                nary_expr: {
                  symbol: "&&",
                  expression_list: [{
                    binary_expr: {
                      left: { var_expr: { var_name: "" } },
                      right: { const_expr: { const: "" } },
                      symbol: ""
                    }
                  }]
                }
              }
            };

          this.model.flow_version.filters = [obj];
        }

        this.createMenuEnd();

        this.veryExistFlowOrder();

        if (this.model.selector_test_flow.status == 0)
          if (this.model.flow_version.status == 0 || this.model.flow_version.status == 4) {
            this.save();

            const source = interval(5000);
            this.subscription = source.subscribe(val => this.save());
          }

        this.model.ab = this.getAB();

        const isTestFlowActive = this.model.selector_test_flow.status === 1;
        const isFlowVersionLocked = this.model.flow_version.status !== 0 && this.model.flow_version.status !== 4;
        const isNotAdmin = !this.model.user.isAdmin;
        const isControlOrA = this.model.ab === "control" || this.model.ab === "A";
        const isBAndTestFlowActive = this.model.ab === "B" && isTestFlowActive;

        this.onlyViewer = isTestFlowActive
          || isFlowVersionLocked
          || isNotAdmin
          || isControlOrA
          || isBAndTestFlowActive;

        this.cdr.detectChanges();

      });

    if (this.router.url.includes("manage")) {
      this.openCreateAb();
    }

    this.setTheme(localStorage[environment.theme]);

    this.loadedFlow = true;

  }

  getMetrics(): void {
    const parms = {
      start_date: this.model.period.start,
      end_date: this.model.period.end,
      selector_test: this.model.selector_test,
      snapshot_id: this.model.snapshot_id
    };

    this.metrics$ = this.flowService.getMetrics(this.model.partner, this.model.account, parms).pipe(shareReplay());

    this.metrics$.subscribe({
      next: success => {
        if (success.selector_test_flows) {
          this.model.selector_test = success;

          // Atualiza os fluxos
          this.updateSelectorTestFlows(success.selector_test_flows);

          // Calcula totais
          this.calculateTotals();

          // Ordena os fluxos
          this.sortSelectorTestFlows();

          // Atualiza o fluxo selecionado
          this.updateSelectedFlow();

          this.cdr.detectChanges();

        }
      },
      error: () => {
        this.error = true;
        this.cdr.detectChanges();
      }
    });
  }

  /**
   * Atualiza os fluxos com base nos dados recebidos.
   */
  private updateSelectorTestFlows(flows: any[]): void {
    flows.forEach((updatedFlow, index) => {
      const flow = this.model.selector_test.selector_test_flows[index] || {};
      this.updateFlow(flow, updatedFlow);
      this.model.selector_test.selector_test_flows[index] = flow;
    });
    this.cdr.detectChanges();
  }

  /**
   * Atualiza os valores de um fluxo com base nos dados recebidos.
   */
  private updateFlow(flow: any, updatedFlow: any): void {
    flow.transaction_amount_percent = updatedFlow.transaction_amount_percent;
    flow.transaction_amount = updatedFlow.transaction_amount;
    flow.net_amount_percent = updatedFlow.net_amount_percent;
    flow.net_amount = updatedFlow.net_amount;
    flow.approved_amount_percent = updatedFlow.approved_amount_percent;
    flow.approved_amount = updatedFlow.approved_amount;
    flow.fees_amount_percent = updatedFlow.fees_amount_percent;
    flow.fee_amount = updatedFlow.fee_amount;
    flow.fraud_costs_amount_percent = updatedFlow.fraud_costs_amount_percent;
    flow.fraud_amount = updatedFlow.fraud_amount;

    if (updatedFlow.transaction_amount_percent) {
      flow.transaction_amount_percent_string = this.transactionAmountPercent(updatedFlow.transaction_amount_percent);
    }
  }

  /**
   * Calcula os totais de transações e atualiza os fluxos.
   */
  private calculateTotals(): void {
    let transaction_amount = 0.0;
    let transaction_count = 0;

    this.model.selector_test?.selector_test_flows?.forEach(stf => {
      transaction_amount += stf.transaction_amount || 0;
      transaction_count += stf.transaction_count || 0;
      stf.transaction_amount_percent_string = this.transactionAmountPercent(stf.transaction_amount_percent);
    });

    this.model.transaction_amount_total = transaction_amount;
    this.model.transaction_count_total = transaction_count;
  }

  /**
   * Ordena os fluxos com base na ordem.
   */
  private sortSelectorTestFlows(): void {
    this.model.selector_test.selector_test_flows = this.model.selector_test.selector_test_flows?.sort((n1, n2) => n1.order - n2.order);
  }

  /**
   * Atualiza o fluxo selecionado com base nos critérios.
   */
  private updateSelectedFlow(): void {
    const selector_test_flow = this.model.selector_test.selector_test_flows?.find(p =>
      p.flow_id === this.model.selector_test_flow.flow_id &&
      p.version === this.model.selector_test_flow.version &&
      p.order === this.model.selector_test_flow.order
    );

    this.model.selector_test_flow = selector_test_flow;
  }

  /**
   * Converte um valor decimal em uma string de percentual.
   */
  transactionAmountPercent(decimal: number): string {
    const percent = decimal * 100;

    if (percent > 0 && percent < 1) {
      return '<1%';
    } else if (percent >= 1) {
      return `${Math.round(percent)}%`;
    }
    return '0%';
  }

  checkASDropped() {
    const { authorization_scheme, flow_orders } = this.model.flow_version;

    const orderAlternative = flow_orders.find(order => order.type === 'alternateauthorize')
      ?.actions[0]?.action.authorization_scheme;
    const zeroAuth = flow_orders.find(order => order.type === 'zeroauth')
      ?.actions[0]?.action.authorization_scheme;

    this.model.authorization_schemes.forEach(scheme => {
      scheme.dropped = [authorization_scheme?.id, orderAlternative?.id, zeroAuth?.id].some(id => scheme.id === id);

      scheme.steps.forEach(step => {
        if (!step) return;
        ['first_service', 'second_service', 'third_service'].forEach(serviceKey => {
          const service = step[serviceKey];
          if (service?.name) {
            service.image_path = this.ServicesLogosService.getImgURL(service.name.toLowerCase());
          }
        });
      });
    });

    this.cdr.detectChanges();
  }


  createMenuEnd() {
    const existsType = (type: string) => {
      return this.model.flow_version.flow_orders?.some(p => p.type.toLowerCase() === type.toLowerCase());
    };

    const setMenuEnd = (type: string) => {
      this.menuEnd = type;
      return {
        key: this.uuidv4(),
        actions: [{ action: { type } }],
        type,
        custom_data: { type }
      };
    };

    if (existsType('waitoncapture')) this.menuEnd = 'waitoncapture';
    if (existsType('cancel')) this.menuEnd = 'cancel';
    if (existsType('capture')) this.menuEnd = 'capture';
    if (existsType('approve')) this.menuEnd = 'approve';
    if (existsType('denied')) this.menuEnd = 'denied';
    if (existsType('waitantifraud')) this.menuEnd = 'waitantifraud';

    let menu_end;

    const flowTypeId = this.model.flow_version.flow.flow_type_id;
    const noSpecialFlows = !existsType('waitoncapture') && !existsType('cancel') && !existsType('capture') &&
      !existsType('approve') && !existsType('denied') && !existsType('waitantifraud');

    if (noSpecialFlows) {
      if (flowTypeId === 0) {
        menu_end = setMenuEnd('capture');
      } else if (flowTypeId === 1) {
        menu_end = setMenuEnd('approve');
      }
    }

    if (menu_end) {
      this.model.flow_version.flow_orders.push(menu_end);
    }

    this.cdr.detectChanges();
  }

  containsServiceTuna() {
    var containsTuna = [];

    this.model.flow_version.authorization_scheme?.steps?.forEach(step => {
      if (step) {
        if (step.first_service) {
          if (step.first_service.name)
            if (step.first_service.name.toLowerCase().includes('Tuna Split para Cartão'))
              containsTuna.push(step.first_service.name);
        }
        if (step.second_service) {
          if (step.second_service.name)
            if (step.second_service.name.toLowerCase().includes('Tuna Split para Cartão'))
              containsTuna.push(step.second_service.name);
        }
        if (step.third_service) {
          if (step.third_service.name)
            if (step.third_service.name.toLowerCase().includes('Tuna Split para Cartão'))
              containsTuna.push(step.third_service.name);
        }
      }
    });

    this.model.isContainsServiceTuna = containsTuna.length > 0 ? true : false;
  }

  ngAfterViewInit(): void {
    this.firstOpen = false;
    this.cdr.detectChanges();
  }

  addFilterFlowDefault() {
    return {
      name: "Default Flow",
      expression: {
        nary_expr: {
          symbol: "&&",
          expression_list: [
            {
              binary_expr: {
                left: {
                  var_expr: {
                    var_name: "Transaction"
                  }
                },
                right: {
                  const_expr: {
                    const: "All transactions"
                  }
                },
                symbol: "is equals to"
              }
            }
          ]
        }
      }
    }
  }

  changeInput(obj) {
    this.model.flow_version.flow_orders.find(p => p.key == obj.key).name = obj.name;
  }

  setTheme(theme: string) {
    this.model.theme = theme ?? this.model.themes.light;
    this.model.isDarkTheme = theme == this.model.themes.dark;
    this.model.isDarkTheme
      ? this.renderer.addClass(document.body, this.model.darkClass)
      : this.renderer.removeClass(document.body, this.model.darkClass);
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  mountDefinition() {

    var arrayForSave = JSON.parse(JSON.stringify(this.model.flow_version.flow_orders));
    var filterForSave = JSON.parse(JSON.stringify(this.model.flow_version.filters));

    if (arrayForSave.length > 0 && filterForSave.length > 0) {
      arrayForSave.forEach((p, index) => {
        p.key = p.key ? p.key : this.uuidv4();

        const typeMap = {
          antifraud: 'Antifraud',
          capture: 'Capture',
          authorize: 'Authorize',
          approve: 'Approve',
          denied: 'Denied',
          waitantifraud: 'WaitAntifraud',
          zeroauth: 'ZeroAuth'
        };

        const specialTypes = ['waitoncapture', 'cancel', 'capture', 'approve', 'denied', 'waitantifraud'];

        if (p.type && typeMap[p.type]) {
          p.type = typeMap[p.type];
        }

        p.custom_data = { type: p.type, name: p.name };

        if (specialTypes.includes(p.type.toLowerCase())) {
          p.order_id = arrayForSave.length + 1;
        } else {
          p.order_id = index + 1;
        }

        delete p.type;
        delete p.name;
        delete p.services;
        delete p.diff_status;


        p.actions.forEach(action => {
          delete action.action.actions;
          delete action.action.table_id;
          delete action.action.variables;
          delete action.action.typeDescription;
          delete action.action.actions_filtered;
          delete action.action.authorization_scheme?.steps;

          if (action.action.type.toLowerCase() != 'antifraud'
            && action.action.type.toLowerCase() != 'checkenrollment' && action.action.type.toLowerCase() != 'challengeresult')
            delete action.action.config_name;

          const actionTypeMap = {
            dummy: 'Dummy',
            denied: 'Denied',
            gotoauthorize: 'GoToAuthorize',
            antifraud: 'AntiFraud',
            authorize: 'Authorize',
            capture: 'Capture',
            cancel: 'Cancel',
            script: 'Script',
            waitantifraud: 'WaitAntifraud',
            waitgateway: 'WaitGateway',
            waitoncapture: 'WaitOnCapture',
            accumulatereturningcapture: 'AccumulateReturningCapture',
            waitanyantifraud: 'WaitAnyAntifraud',
            waitanyapprovedantifraud: 'WaitAnyApprovedAntifraud',
            approve: 'Approve',
            gotoaccumulatereturningcapture: 'GotoAccumulateReturningCapture',
            zeroauth: 'ZeroAuthorize'
          };

          const filteredActionTypeMap = this.model.user.realm === 'angeloni'
            ? actionTypeMap
            : Object.keys(actionTypeMap).reduce((acc, key) => {
              if (key !== 'gotoaccumulatereturningcapture') {
                acc[key] = actionTypeMap[key];
              }
              return acc;
            }, {} as Record<string, string>);

          if (action?.action?.type && filteredActionTypeMap[action.action.type]) {
            action.action.type = filteredActionTypeMap[action.action.type];
          }

          if (action.filters) {
            delete action.filters.expression.nary_expr.to_test;
            action.filters.expression.nary_expr.expression_list.forEach(element => {
              delete element.binary_expr.id;
              delete element.binary_expr.options;
              delete element.binary_expr.operators;
              delete element.binary_expr.variables;
              delete element.binary_expr.values;
              delete element.binary_expr.operators_filtered;
              delete element.binary_expr.variables_filtered;
              delete element.binary_expr.values_filtered;
              delete element.binary_expr.terms_filtered;

            });
          }
        });

      });

      arrayForSave = arrayForSave.sort((n1, n2) => n1.order_id - n2.order_id);
      for (let index = 0; index < arrayForSave.length; index++) //reordena sequencial
        arrayForSave[index].order_id = index + 1;

      arrayForSave = arrayForSave.sort((n1, n2) => n1.order_id - n2.order_id);

      filterForSave.forEach((p, index) => {
        if (p) {
          p.custom_data = { type: p.type, name: p.name }

          delete p.disabled;
          delete p.table_id;
          if (p.expression) {
            delete p.expression.nary_expr.to_test;
            p.expression.nary_expr.expression_list.forEach(element => {
              element.binary_expr.symbol = element.binary_expr.symbol_not_translate;
              delete element.binary_expr.symbol_not_translate;
              delete element.id;

              delete element.binary_expr.terms;
              delete element.binary_expr.operators;
              delete element.binary_expr.values;
              delete element.binary_expr.operators_filtered;
              delete element.binary_expr.variables_filtered;
              delete element.binary_expr.values_filtered;
              delete element.binary_expr.terms_filtered;
            });
          }
        }

      });



      return {
        flows: arrayForSave,
        filters: this.model.flow_version.is_default ? [] : filterForSave
      };

    }
  }

  save() {

    if ((this.model.is_ab && this.model.ab == "B") || !this.model.is_ab) {
      var definition = this.mountDefinition();
      var flow = {
        flow_id: parseInt(this.model.flow_id),
        version: parseInt(this.model.version),
        authorization_scheme_id: this.model.flow_version.authorization_scheme ? this.model.flow_version.authorization_scheme.id : null,
        definition: JSON.stringify(definition)
      };

      if (!this.model.flow_old)
        this.model.flow_old = JSON.stringify(definition);

      if (this.model.flow_old != JSON.stringify(definition)) {

        if (this.model.user.isAdmin) {

          this.saving = true;

          this.flowsService.save(this.model.partner, this.model.account, flow).subscribe(response => {
            this.model.flow_old = JSON.stringify(definition);
            this.saving = false;
            this.model.flow_version.last_update_date_gmt = moment().format("dd/MM/YY HH:mm:ss");
          },
            (error) => {
              this.saving = false;
              if (error.result.length > 0) {
                error.result.forEach(element => {
                  this.toastr.error(element.message);
                });
              }
            });
        }

        this.loadingService.stop();
      }
    }
  }

  async saveValidate(loading = true) {
    if (this.model.user.isAdmin) {
      var definition = this.mountDefinition();
      var flow = {
        flow_id: parseInt(this.model.flow_id),
        version: parseInt(this.model.version),
        authorization_scheme_id: this.model.flow_version.authorization_scheme ? this.model.flow_version.authorization_scheme.id : null,
        definition: JSON.stringify(definition)
      };

      this.flowsService.save(this.model.partner, this.model.account, flow, loading).subscribe(response => {
        this.model.flow_old = JSON.stringify(definition);
        this.saving = false;
        this.model.flow_version.last_update_date_gmt = moment().format("dd/MM/YY HH:mm:ss");
      },
        (error) => {
          this.saving = false;
          if (error.result.length > 0) {
            error.result.forEach(element => {
              this.toastr.error(element.message);
            });
          }
        });
    }
  }

  veryExistFlowOrder() {
    this.model.flow_version.flow_orders_actions_exists = this.model.flow_version.flow_orders.some(p => p.type == 'action' || p.type == 'antifraud' || p.type == "checkenrollment");
  }

  menu(value) {

    this.menuEnd = value;

    const targetTypes = [
      "Capture",
      "WaitOnCapture",
      "Cancel",
      "Approve",
      "Denied",
      "WaitAntifraud"
    ].map(t => t.toLowerCase()); // Convertendo para minúsculas

    const end = this.model.flow_version.flow_orders.find(p =>
      targetTypes.includes(p.type.toLowerCase())
    );

    const index = this.model.flow_version.flow_orders.indexOf(end);

    if (index > -1) {
      this.model.flow_version.flow_orders.splice(index, 1);
    }

    let event = {
      key: this.uuidv4(),
      actions: [
        {
          action: {
            type: value
          }
        }
      ],
      type: value,
      custom_data: { type: value }
    }

    this.model.flow_version.flow_orders.push(event);
  }

  getAB() {
    if (this.model.index_ab == 0 && this.model.is_ab) {
      this.titleService.setTitle(this.translateService.instant('flows.detail.title') + ' • ' + this.model.flow_version.flows_descriptor[0].name);
      return 'control';
    } else {

      if (this.model.index_ab == 1 && this.model.is_ab) {
        this.titleService.setTitle(this.translateService.instant('flows.detail.title') + ' • ' + this.model.flow_version.flows_descriptor[1].name);
        return 'A';
      }

      if (this.model.index_ab == 2 && this.model.is_ab) {
        this.titleService.setTitle(this.translateService.instant('flows.detail.title') + ' • ' + this.model.flow_version.flows_descriptor[2].name);
        return 'B';
      }

      this.titleService.setTitle(this.translateService.instant('flows.detail.title') + ' • ' + (this.model.flow_version.is_default ? this.translateService.instant('flows.detail.default.text') : this.model.selector_test.selector_test_flows[0].name));
      return 'normal';
    }
  }

  getService(flow_orders) {

    var services = [];
    if (flow_orders) {
      var reverse = flow_orders;

      for (let index = 0; index < reverse.length; index++) {
        const element = flow_orders[index];

        const element_service = flow_orders[index];

        var obj_service = this.model.services.find(p => p.custom_name == element_service.actions[0].action.config_name);

        if (obj_service)
          element_service.actions[0].action.config_name = obj_service.custom_name;

        var obj_service3ds = this.model.threeds.find(p => p.service_name?.toLowerCase() == element_service.actions[0].action.config_name?.toLowerCase() || (p.service_name?.toLowerCase() == element_service.actions[0].action.service?.toLowerCase()));

        if (obj_service3ds)
          element_service.actions[0].action.config_name = obj_service3ds.service_name;

        var variables = this.model.filter_antifrauds.find(p => p.service.toLowerCase().trim() == (element_service.actions[0].action.service ? element_service.actions[0].action.service.toLowerCase().trim().normalize("NFD").replace(/\s/g, '') : null));

        var variables3ds = this.model.filter_3ds.find(p => p.service.toLowerCase().trim() == (element_service.actions[0].action.service ? element_service.actions[0].action.service.toLowerCase().trim().normalize("NFD").replace(/\s/g, '') : null));

        const myClonedArray = [];

        if (variables && variables?.tuna_type?.toLowerCase() != "threeds")
          if (variables?.variables?.length) {
            variables.variables.forEach(val => myClonedArray.push(Object.assign({}, val)));
            myClonedArray.forEach(element => {
              if (obj_service)
                if (obj_service.custom_name)
                  if (element.name) {
                    element.name = obj_service.custom_name.trim().normalize("NFD").replace(/\s/g, '_').replace(/[^a-zA-Z0-9_]/g, "_") + element.name.substr(element.name.indexOf('.'));
                    element.tuna_type = obj_service.type.name
                  }
            });
          }


        if (variables3ds && variables3ds?.tuna_type?.toLowerCase() == "threeds")
          if (variables3ds?.variables?.length) {
            variables3ds.variables.forEach(val => myClonedArray.push(Object.assign({}, val)));
            myClonedArray.forEach(element => {
              if (obj_service3ds)
                if (obj_service3ds.service_name)
                  if (element.name) {
                    element.name = obj_service3ds.service_name.trim().normalize("NFD").replace(/\s/g, '_').replace(/[^a-zA-Z0-9_]/g, "_") + element.name.substr(element.name.indexOf('.'));
                  }
            });
          }


        if (obj_service)
          if (element_service.actions[0].action.service_id > 0) {
            services.push(
              {
                id: obj_service.service_id,
                service: obj_service.service_name,
                tuna_type: obj_service.type.name,
                config_name: obj_service ? obj_service.custom_name : null,
                version: obj_service.version_id,
                variables: variables ? myClonedArray : []
              });
          }


        if (obj_service3ds)
          if (element_service.actions[0].action.service_id > 0) {
            services.push(
              {
                id: obj_service3ds.service_id,
                service: obj_service3ds.service_name,
                config_name: obj_service3ds ? obj_service3ds.custom_name : null,
                version: obj_service3ds.version_id,
                variables: variables3ds ? myClonedArray : []
              });
          }



        if (element.actions[0].action.service)
          if (this.model.services.some(p => p.custom_name == element.actions[0].action.config_name))
            this.model.services.find(p => p.custom_name == element.actions[0].action.config_name).dropped = true;

        flow_orders[index].services = services.filter((service, index, self) =>
          index === self.findIndex((t) => (
            t.id === service.id && t.version === service.version
          ))
        )
      }
      return reverse;
    }
  }

  validateAllFormFields(formGroup: FormGroup) {

    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);

      if (control.value) {
        if (control instanceof FormControl) {
          control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
          this.validateAllFormFields(control);
        }
      }
    });

  }

  returnMsgErrorPublish() {


    if (!this.form.valid && this.model.flow_version.is_default && this.model.flow_version.flow_orders.length > 2)
      return 'flows.detail.publish.disabledTooltip';

    if (!this.form.valid && !this.model.flow_version.is_default)
      return 'flows.detail.publish.disabledTooltip';

    if (this.model.flow_version.authorization_scheme) {
      if (!(this.model.flow_version.authorization_scheme.id > 0))
        return 'flows.detail.publish.authorization_scheme_tooltip';

      if (this.model.flow_version.filters.length == 0 && !this.model.flow_version.is_default)
        return 'flows.detail.publish.disabledTooltip';
    }

    this.containsServiceTuna();

    if (this.model.isContainsServiceTuna) {
      if (this.model.flow_version.flow_orders.length > 0) {
        if (!(this.model.flow_version.flow_orders?.map(p => p.type)?.find(p => p == 'antifraud')?.length > 0))
          return 'flows.detail.publish.contains_service_tuna_tooltip';
      }
    }

    return '';

  }

  onWindowScroll() {
    if (window.scrollY > 0) {
      this.header.nativeElement.classList.add('fixed');
    } else {
      this.header.nativeElement.classList.remove('fixed');
    }
    this.iconFlowTop = this.header.nativeElement.offsetHeight + 15 + 'px';
  }

  collapseAllToggle() {
    this.expandedStepState = !this.expandedStepState;
  }

  flowsList() {
    this.loadingService.start();
    if (this.model.snapshot_id)
      this.router.navigate([this.model.partner, this.model.account, 'snapshot', this.model.snapshot_id]);
    else
      this.router.navigate([this.model.partner, this.model.account, 'snapshot']);
  }

  changeTest(flow_id, version_id, order) {
    this.router.navigate([this.model.partner, this.model.account, 'snapshot', this.model.snapshot_id, 'flow',
    this.model.selector_test.id, flow_id,
      version_id, order,
    this.model.period.start.format('YYYY-MM-DD'),
    this.model.period.end.format('YYYY-MM-DD'),
    this.model.orders]);

    setTimeout(() => {
      this.scrollTestTabs();
    }, 500);
  }

  scrollTestTabs() {
    const activeTab = this.elementRef.nativeElement.querySelectorAll('.test-menu .tab.active')[0];
    const tabList = this.elementRef.nativeElement.querySelectorAll('.tab-list')[0];
    const tabListScrollPosition: number = tabList.scrollLeft;
    const positionScrollTo = this.calcScrollXToCenter(activeTab, tabListScrollPosition);
    tabList.scroll({
      left: positionScrollTo,
      behavior: 'smooth',
    });
  }

  calcScrollXToCenter(activeTab, tabListScrollPosition): number {
    const activeTabDom: DOMTabList = (activeTab as HTMLElement).getBoundingClientRect();
    const leftXOffset = (window.innerWidth - activeTabDom.width) / 2;
    const visibleViewportLeft = activeTabDom.left;
    const neededLeftOffset = visibleViewportLeft - leftXOffset;
    const valueToScroll = tabListScrollPosition + neededLeftOffset;
    return valueToScroll;
  }

  openPeriod() {
    const dialog = this.dialog.open(PeriodModalComponent, {
      width: '500px',
      data: { period: this.model.period },
      autoFocus: false
    });

    dialog.afterClosed().subscribe(result => {
      if (result) {

        var start = moment(result.start).format('YYYY-MM-DD');
        var end = moment(result.end).format('YYYY-MM-DD');
        this.router.navigate([this.model.partner, this.model.account, 'snapshot', this.model.snapshot_id, 'flow', this.model.selector_test.id, this.model.flow_id, this.model.version, this.model.order, start, end]);
      }
    });
  }

  testAb() {

  }

  addFilter() {
    var obj = {
      name: this.translateService.instant('flows.detail.filter_name'),
      expression: {
        nary_expr: {
          symbol: "&&",
          expression_list: [
            {
              binary_expr: {
                left: {
                  var_expr: {
                    var_name: ""
                  }
                },
                right: {
                  const_expr: {
                    const: ""
                  }
                },
                symbol: ""
              }
            }
          ]
        }
      },
    }
    this.model.flow_version.filters.push(obj);
  }

  removeFilter(filter) {

    let obj = this.model.flow_version.filters.find(p => p == filter)

    obj.expression.nary_expr.expression_list.forEach(expression => {
      this.form.removeControl('options' + expression.binary_expr.id);
      this.form.removeControl('operators' + expression.binary_expr.id);
      this.form.removeControl('values' + expression.binary_expr.id);
    });

    const index = this.model.flow_version.filters.indexOf(obj);
    if (index > -1) {
      this.model.flow_version.filters.splice(index, 1);
    }
  }

  drop(event: CdkDragDrop<any[]>) {

    var objCurrent = event.previousContainer.data[event.previousIndex] as any;

    if (objCurrent.type != 'manualanalysis' && objCurrent.type != 'capture') {

      if (event.previousContainer.data[event.previousIndex]) {
        var result = event.previousContainer.data[event.previousIndex] as any;
        //verifica se é antifraud ou AS
        if (result.type == 'authorize' || result.steps) {

          if (result.name.includes("Zero Auth"))
            this.dropASZeroAuth(event, result);
          else
            this.dropAS(event, result);


        } else if (result.type?.id == 'G') {
          this.dropActions3ds(event, result);
        } else {
          this.dropActions(event, result);
        }
      }
      this.expandedStepState = true;

      this.cdr.detectChanges();
    }

  }

  dropAS(event: CdkDragDrop<any>, result) {
    const selectedScheme = this.model.authorization_schemes.find(p => p.id == result.id);
    if (!selectedScheme) return;

    const flowOrders = this.model.flow_version.flow_orders;
    const isAuthorizePresent = flowOrders.some(p => p.type === 'authorize');
    const isSameAuthScheme = this.model.flow_version.authorization_scheme?.id === result.id;

    if (isAuthorizePresent && isSameAuthScheme) {
      moveItemInArray(flowOrders, event.previousIndex, event.currentIndex);
      return;
    }

    this.removeAS();

    const objAdd = {
      actions: [{ action: { type: "authorize" } }],
      custom_data: { type: "authorize", name: "" },
      type: "authorize",
      name: result.name,
      id: result.id,
      key: this.uuidv4()
    };

    this.model.flow_version.authorization_scheme = selectedScheme;
    transferArrayItem([objAdd], flowOrders, event.previousIndex, event.currentIndex);

    this.model.authorization_schemes = this.model.authorization_schemes.map(element => ({
      ...element,
      dropped: element.dropped || element.id === result.id
    }));

    this.model.flow_version.authorization_scheme_id = result.id;
    this.model.flow_version.flow_orders = this.getService(flowOrders);

    this.containsServiceTuna();
  }


  dropASZeroAuth(event: CdkDragDrop<any>, result) {
    const selectedScheme = this.model.authorization_schemes.find(p => p.id == result.id);
    if (!selectedScheme) return;

    const isZeroAuthPresent = this.model.flow_version.flow_orders.some(p => p.type == 'zeroauth');

    if (isZeroAuthPresent) {
      moveItemInArray(this.model.flow_version.flow_orders, event.previousIndex, event.currentIndex);
      return;
    }

    const objAdd = {
      actions: [{
        action: {
          type: "zeroauthorize",
          authorization_scheme: selectedScheme
        }
      }],
      custom_data: { type: 'zeroauth', name: 'Check Zero Auth' },
      type: "zeroauth",
      name: selectedScheme.name,
      key: this.uuidv4()
    };

    transferArrayItem([objAdd], this.model.flow_version.flow_orders, event.previousIndex, event.currentIndex);

    const action = {
      key: this.uuidv4(),
      name: "Action based on Zero Auth",
      type: "action",
      actions: [{
        action: { type: "denied" },
        filters: {
          name: this.translateService.instant('flows.detail.action_name'),
          expression: {
            nary_expr: {
              symbol: "&&",
              expression_list: [
                {
                  binary_expr: {
                    left: { var_expr: { var_name: "ZeroAuthorize.Status" } },
                    right: { const_expr: { const: "authorized" } },
                    symbol: "not equals to"
                  }
                }
              ]
            }
          }
        }
      }],
      custom_data: { name: "Action based on Zero Auth", type: "action" }
    };

    transferArrayItem([action], this.model.flow_version.flow_orders, event.currentIndex + 1, event.currentIndex + 2);

    this.checkASDropped();
  }

  dropActions(event: CdkDragDrop<any>, result) {
    const service = event.previousContainer.data[event.previousIndex] as any;

    if (service.id === 'action') {
      this.createCustomActions(event);
    } else if (
      service.id === 'action_wait_any_antifraud' ||
      service.id === 'action_wait_any_approved_antifraud' ||
      service.id === 'action_accumulate'
    ) {
      this.createWaitAnyAntifraud(service, event);
    } else {
      this.createAntifraudService(service, event);
    }

    this.model.flow_version.flow_orders = this.getService(
      this.model.flow_version.flow_orders
    );
  }

  private createCustomActions(event: CdkDragDrop<any>) {
    const name = this.translateService.instant('flows.detail.custom_action_title');
    const antifraud = this.createAntifraudAction([
      this.createAction('capture'),
      this.createAction('cancel'),
    ], name);

    this.veryExistFlowOrder();
    transferArrayItem(
      [antifraud],
      this.model.flow_version.flow_orders,
      event.currentIndex,
      event.currentIndex + 1
    );
  }

  private createWaitAnyAntifraud(service: any, event: CdkDragDrop<any>) {
    const name = this.translateService.instant(
      'flows.detail.action_wait_any_antifraud_title'
    );

    const typeMap: { [key: string]: string } = {
      action_wait_any_antifraud: 'WaitAnyAntifraud',
      action_wait_any_approved_antifraud: 'WaitAnyApprovedAntifraud',
      action_accumulate: 'GotoAccumulateReturningCapture'
    };

    const type = typeMap[service.id] || undefined;

    const antifraud = this.createAntifraudAction(
      [{ action: { type } }],
      name
    );

    this.veryExistFlowOrder();
    transferArrayItem(
      [antifraud],
      this.model.flow_version.flow_orders,
      event.currentIndex,
      event.currentIndex + 1
    );
  }

  private createAntifraudService(service: any, event: CdkDragDrop<any>) {
    if (
      this.model.services.find(
        (p) =>
          p.custom_name === service.custom_name ||
          p.service_name === service.custom_name
      )?.dropped
    ) {
      return;
    }

    if (!this.model.flow_version.flow_orders.some((p) => p.key === service.key)) {
      const name = this.translateService.instant('flows.detail.risk', {
        antifraud: service.custom_name,
      });
      const nameAction = this.translateService.instant(
        'flows.detail.custom_action',
        { antifraud: service.custom_name }
      );
      const nameResult = this.translateService.instant('flows.detail.result');



      const action = {
        key: this.uuidv4(),
        actions: [
          {
            action: {
              type: 'antifraud',
              service_id: service.service_id,
              service: service.service_name,
              version: service.version_id,
              config_name: service.custom_name,
            },
          },
        ],
        custom_data: { type: 'antifraud', name },
        type: 'antifraud',
        name,
        service_id: service.service_id,
        version_id: service.version_id,
      };

      transferArrayItem(
        [action],
        this.model.flow_version.flow_orders,
        event.previousIndex,
        event.currentIndex
      );

      var serviceConfig = this.antifraud_actions_config.find(p => p.id == service.service_name.toLowerCase());
      let antifraud;
      if (serviceConfig) {
        antifraud = this.createAntifraudAction([serviceConfig.config], `${nameAction} ${service.custom_name} ${nameResult}`,
          service);
      } else {

        const actionType = this.getActionTypes();
        antifraud = this.createAntifraudAction(
          [
            this.createAction(actionType.approve),
            this.createAction(actionType.reject),
          ],
          `${nameAction} ${service.custom_name} ${nameResult}`,
          service
        );
      }

      this.veryExistFlowOrder();
      transferArrayItem(
        [antifraud],
        this.model.flow_version.flow_orders,
        event.currentIndex,
        event.currentIndex + 1
      );

      this.model.services.find(
        (p) => p.custom_name === service.custom_name
      ).dropped = true;
    } else {
      moveItemInArray(
        this.model.flow_version.flow_orders,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  private createAntifraudAction(actions, name, service = null) {
    return {
      key: this.uuidv4(),
      actions,
      type: 'action',
      custom_data: { type: 'action', name },
      name,
      services: service
        ? [
          {
            id: service.service_id,
            service_name: service.service_name,
            version: service.version_id,
            variables: this.getAntifraudVariables(service.service_name),
          },
        ]
        : [],
    };
  }

  private createAction(type: string) {

    return {
      action: { type },
      filters: {
        name: this.translateService.instant('flows.detail.action_name'),
        expression: {
          nary_expr: {
            symbol: '&&',
            expression_list: [
              {
                binary_expr: {
                  left: {
                    var_expr: { var_name: '', tuna_type: 'Antifraud' },
                  },
                  right: { const_expr: { const: '' } },
                  symbol: '',
                },
              },
            ],
          },
        },
      },
    };
  }

  private getActionTypes() {
    if (this.model.flow_version.flow.flow_type_id === 0) {
      return { approve: 'capture', reject: 'cancel' };
    } else if (this.model.flow_version.flow.flow_type_id === 1) {
      return { approve: 'approve', reject: 'denied' };
    }
  }

  private getAntifraudVariables(serviceName: string) {
    const normalizedServiceName = serviceName
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/\s/g, '_')
      .replace(/[^a-zA-Z0-9_]/g, '_');

    return this.model.filter_antifrauds.find(
      (p) => p.service.toLowerCase() === normalizedServiceName
    )?.variables || [];
  }


  dropActions3ds(event: CdkDragDrop<any>, result) {
    const service = event.previousContainer.data[event.previousIndex] as any;

    if (!this.model.threeds.find((p) => p.custom_name === service.custom_name || p.service_name === service.service_name)?.dropped) {
      if (!this.model.flow_version.flow_orders.some((p) => p.key === service.key)) {
        const nameAction = this.translateService.instant('flows.detail.custom_action_3ds', { antifraud: service.service_name });
        const nameResult = this.translateService.instant('flows.detail.result');

        var name = this.translateService.instant('flows.detail.risk', { antifraud: service.service_name });
        var service3ds = {
          key: this.uuidv4(),
          actions: [
            {
              action: {
                type: "checkenrollment",
                service_id: service.service_id,
                service: service.service_name,
                version: service.version_id,
                config_name: service.service_name
              },
            }],
          custom_data: { type: 'checkenrollment', name: name },
          type: "checkenrollment",
          name: name,
          service_id: service.service_id,
          version_id: service.version_id
        };

        transferArrayItem([service3ds], this.model.flow_version.flow_orders, event.previousIndex, event.currentIndex);

        this.addService3dsActions(service, nameAction, nameResult, event);

        this.model.threeds.find((p) => p.service_name === service.service_name).dropped = true;
        this.veryExistFlowOrder();
      } else {
        moveItemInArray(this.model.flow_version.flow_orders, event.previousIndex, event.currentIndex);
      }
    }

    this.model.flow_version.flow_orders = this.getService(this.model.flow_version.flow_orders);
  }

  private addService3dsActions(service, nameAction, nameResult, event) {

    const actions2 = [
      { type: "denied", varName: "CheckEnrollment.Status", constValue: "error" },
      { type: "denied", varName: "CheckEnrollment.AuthenticationResult", constValue: "failed" },
    ];

    const service3ds2 = this.createService3ds(this.uuidv4(), actions2, service, nameAction, nameResult);

    const actions3 = [
      { type: "challengeresult", varName: "CheckEnrollment.AuthenticationResult", constValue: "pendingAuthentication" },
    ];

    const service3ds3 = this.createService3ds(this.uuidv4(), actions3, service, nameAction, nameResult);

    const actions4 = [
      { type: "denied", varName: "CheckEnrollment.Status", constValue: "error" },
    ];
    const service3ds4 = this.createService3ds(this.uuidv4(), actions4, service, nameAction, nameResult);

    const actions5 = [
      { type: "denied", varName: "CheckEnrollment.AuthenticationResult", constValue: "failed" },
    ];

    const service3ds5 = this.createService3ds(this.uuidv4(), actions5, service, nameAction, nameResult);

    transferArrayItem([service3ds2], this.model.flow_version.flow_orders, event.currentIndex, event.currentIndex + 1);
    transferArrayItem([service3ds3], this.model.flow_version.flow_orders, event.currentIndex + 1, event.currentIndex + 2);
    transferArrayItem([service3ds4], this.model.flow_version.flow_orders, event.currentIndex + 2, event.currentIndex + 3);
    transferArrayItem([service3ds5], this.model.flow_version.flow_orders, event.currentIndex + 3, event.currentIndex + 4);
  }

  //* AUTHORIZATION SCHEME */
  removeAS() {

    let obj = this.model.flow_version.flow_orders.find(p => p.type == 'authorize')
    const index = this.model.flow_version.flow_orders.indexOf(obj);
    if (index > -1) {
      this.model.flow_version.flow_orders.splice(index, 1);
    }

    if (this.model.flow_version.authorization_scheme_id) {
      this.model.authorization_schemes = this.model.authorization_schemes.map(scheme => ({
        ...scheme,
        dropped: scheme.id === this.model.flow_version.authorization_scheme_id ? false : scheme.dropped
      }));

      this.model.flow_version.authorization_scheme_id = null;
    }

    this.model.flow_version.authorization_scheme = {};

    this.containsServiceTuna();
  }


  //* AUTHORIZATION SCHEME */
  removeASAlternative() {

    let obj = this.model.flow_version.flow_orders.find(p => p.type == 'alternateauthorize')
    const index = this.model.flow_version.flow_orders.indexOf(obj);
    if (index > -1) {
      this.model.flow_version.flow_orders.splice(index, 1);
    }

    if (obj.actions[0].action.authorization_scheme?.id) {
      this.model.authorization_schemes.find(p => p.id == obj.actions[0].action.authorization_scheme?.id).dropped = false;
      this.model.flow_version.authorization_scheme_id = null;
    }

  }

  //* AUTHORIZATION SCHEME */
  removeASZeroAuth() {

    let obj = this.model.flow_version.flow_orders.find(p => p.type == 'zeroauth')
    const index = this.model.flow_version.flow_orders.indexOf(obj);
    if (index > -1) {
      this.model.flow_version.flow_orders.splice(index, 1);
    }

    if (obj.actions[0].action.authorization_scheme?.id) {
      this.model.authorization_schemes.find(p => p.id == obj.actions[0].action.authorization_scheme?.id).dropped = false;
      this.model.flow_version.authorization_scheme_id = null;
    }

  }

  // openAuthorizationScheme(item) {

  //   this.serviceService.filter(this.model.partner, this.model.account, ['G'], true).subscribe(response => {
  //     this.model.servicesAs = response.services.filter(p => p.active);
  //     this.images();

  //     const myClonedArray = [];
  //     this.model.servicesAs.forEach(val => myClonedArray.push(Object.assign({}, val)));

  //     const myClonedArray2 = [];
  //     this.model.servicesAs.forEach(val => myClonedArray2.push(Object.assign({}, val)));

  //     const myClonedArray3 = [];
  //     this.model.servicesAs.forEach(val => myClonedArray3.push(Object.assign({}, val)));


  //     if (!item) { //CREATING
  //       item = {
  //         name: this.translateService.instant('flows.detail.autorization.name'),
  //         steps: [{
  //           first_service: {
  //             services: myClonedArray
  //           },
  //           second_service: {
  //             services: myClonedArray2
  //           },
  //           third_service: {
  //             services: myClonedArray3
  //           },
  //           percentage: 0
  //         }],
  //         can_edit: true
  //       };

  //       const dialog = this.dialog.open(FlowAuthorizationSchemeModalComponent, {
  //         width: '990px',
  //         data: {
  //           partner: this.model.partner,
  //           account: this.model.account,
  //           authorization_scheme: item,
  //           services: this.model.servicesAs

  //         },
  //         autoFocus: false
  //       });

  //       dialog.afterClosed().subscribe(result => {
  //         if (result) {
  //           if (result.createOrEditing == 'creating')
  //             this.model.authorization_schemes.push(result.response.authorization_scheme);
  //           else {
  //             var find = this.model.authorization_schemes.find(p => p.id == result.response.authorization_scheme.id);
  //             let index = this.model.authorization_schemes.indexOf(find);
  //             this.model.authorization_schemes[index] = result.response.authorization_scheme;
  //           }
  //         }
  //       });

  //     } else {  //EDITING

  //       this.authorizationSchemeService.get(this.model.partner, this.model.account, item.id).subscribe(as => {
  //         as.authorization_scheme.can_edit = as.can_edit;

  //         as.authorization_scheme.steps.forEach(step => {
  //           step.first_service.services = myClonedArray;
  //           if (!step.second_service) {
  //             step.second_service = {};
  //           }
  //           if (!step.third_service) {
  //             step.third_service = {};
  //           }

  //           step.second_service.services = myClonedArray2;

  //           step.third_service.services = myClonedArray3;

  //         });

  //         const dialog = this.dialog.open(FlowAuthorizationSchemeModalComponent, {
  //           width: '990px',
  //           data: {
  //             partner: this.model.partner,
  //             account: this.model.account,
  //             authorization_scheme: as.authorization_scheme,
  //             services: this.model.servicesAs
  //           },
  //           autoFocus: false
  //         });

  //         dialog.afterClosed().subscribe(result => {
  //           if (result) {
  //             if (result.createOrEditing == 'creating')
  //               this.model.authorization_schemes.push(result.response.authorization_scheme);
  //             else {
  //               var find = this.model.authorization_schemes.find(p => p.id == result.response.authorization_scheme.id);
  //               let index = this.model.authorization_schemes.indexOf(find);
  //               this.model.authorization_schemes[index] = result.response.authorization_scheme;
  //             }
  //           }
  //         });
  //       },
  //         (error) => {
  //           if (error.result.length > 0) {
  //             error.result.forEach(element => {
  //               this.toastr.error(element.message);
  //             });
  //           }
  //         });
  //     }
  //   },
  //     (error) => {
  //       if (error.result.length > 0) {
  //         error.result.forEach(element => {
  //           this.toastr.error(element.message);
  //         });
  //       }
  //     });
  // }


  openAuthorizationAdd() {
    const dialog = this.dialog.open(AuthorizationEditComponent, {
      maxWidth: '700px',
      width: '100%',
      autoFocus: false,
      data: {
        partner: this.model.partner,
        account: this.model.account,
        state: 'add'
      },
    });

    dialog.afterClosed().subscribe((result) => {
      if (result) {

        this.router.navigate([this.model.partner, this.model.account, 'snapshot', this.model.snapshot_id, 'flow', this.model.selector_test.id, this.model.flow_id, this.model.version, this.model.order, this.model.period.start.format('YYYY-MM-DD'),
        this.model.period.end.format('YYYY-MM-DD'),
        this.model.orders]).then(() => {
          window.location.reload();
        });;
      }
    });
  }

  openAuthorization(item) {

    var dialog = this.dialog.open(AuthorizationEditComponent, {
      maxWidth: '700px',
      width: '100%',
      autoFocus: false,
      data: {
        partner: this.model.partner,
        account: this.model.account,
        authorization_scheme_id: item.id,
        state: 'read_only',
        authorization_scheme: item
      },
    });

    dialog.afterClosed().subscribe((result) => {

      if (result) {

        this.router.navigate([this.model.partner, this.model.account, 'snapshot', this.model.snapshot_id, 'flow', this.model.selector_test.id, this.model.flow_id, this.model.version, this.model.order, this.model.period.start.format('YYYY-MM-DD'),
        this.model.period.end.format('YYYY-MM-DD'),
        this.model.orders]).then(() => {
          window.location.reload();
        });;
      }

    });
  }

  removeAction($event, result) {

    result.actions.forEach(element => {
      this.form.removeControl('actions' + element.id);
      if (element.filters)
        element.filters.expression.nary_expr.expression_list.forEach(expression => {
          this.form.removeControl('options' + expression.binary_expr.id);
          this.form.removeControl('operators' + expression.binary_expr.id);
          this.form.removeControl('values' + expression.binary_expr.id);
        });
    });

    this.form.updateValueAndValidity();

    const service = this.model.flow_version.flow_orders.find(p => p.key === result.key);
    if (service) {
      const index = this.model.flow_version.flow_orders.indexOf(service);
      if (index > -1) {
        this.model.flow_version.flow_orders.splice(index, 1);
      }

      // Função auxiliar para atualizar o campo 'dropped'
      const updateDropped = (serviceName) => {
        const serviceToUpdate = [...this.model.services, ...this.model.threeds]
          .find(p => p.custom_name === serviceName);
        if (serviceToUpdate) {
          serviceToUpdate.dropped = false;
        }
      };

      if (service.type === 'antifraud' || service.type === 'checkenrollment') {
        const serviceName = service.actions[0].action.config_name;
        updateDropped(serviceName);
      }
    }

    this.veryExistFlowOrder();
  }

  images() {
    if (this.model.servicesAs.length > 0) {
      this.model.servicesAs.forEach(element => {
        element.image_path = this.ServicesLogosService.getImgURL(this.normalizeServiceName(element.service_name));
      });
    }
  }

  normalizeServiceName = (serviceName) => {
    return serviceName.toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  addActionManual(obj) {
    if (this.model.flow_version.flow_orders.some(p => p.type == 'manualanalysis')) {
      if (!(obj.action.actions.some(p => p.action.type == 'pendingmanualanalysis'))) {
        let manual = this.model.flow_version.flow_orders.find(p => p.type == 'manualanalysis')
        const index = this.model.flow_version.flow_orders.indexOf(manual);
        if (index > -1) {
          this.model.flow_version.flow_orders.splice(index, 1);
        }
      }
    } else {

      if (obj.type == 'pendingmanualanalysis') {
        var nameAction = this.translateService.instant('flows.detail.custom_action');
        var nameResult = this.translateService.instant('flows.detail.result');
        var antifraud = {
          key: this.uuidv4(),
          actions: [
            {
              action: {
                type: "capture",
                service_id: obj.service.service_id,
                service: obj.service_name,
                config_name: obj.custom_name
              },
              filters: {
                name: "Action Name",
                expression: {
                  nary_expr: {
                    symbol: "&&",
                    expression_list: [
                      {
                        binary_expr: {
                          left: {
                            var_expr: {
                              var_name: "Manual Analysis",
                              tuna_type: "Antifraud"
                            }
                          },
                          right: {
                            const_expr: {
                              const: "passed"
                            }
                          },
                          symbol: "is equal to"
                        }
                      }
                    ]
                  }
                }
              }
            },
            {
              action: {
                type: "cancel",
                service_id: obj.service.service_id,
                service: obj.service_name,
                config_name: obj.custom_name

              },
              filters: {
                name: "Action Name",
                expression: {
                  nary_expr: {
                    symbol: "&&",
                    expression_list: [
                      {
                        binary_expr: {
                          left: {
                            var_expr: {
                              var_name: "Manual Analysis",
                              tuna_type: "Antifraud"
                            }
                          },
                          right: {
                            const_expr: {
                              const: "not passed"
                            }
                          },
                          symbol: "is equal to"
                        }
                      }
                    ]
                  }
                }
              }
            }],
          type: "manualanalysis",
          custom_data: { type: 'manual', name: nameAction + " " + obj.service.service_name + " " + nameResult },
          name: nameAction + " " + obj.service.service_name + " " + nameResult,
          service_id: obj.service.service_id,
          disabled: true
        };
        this.model.flow_version.flow_orders.push(antifraud);

      }


    }

    this.veryExistFlowOrder();
  }

  openPublishFlowBetaModal() {
    this.dialog.open(FlowPublishModal, {
      width: '700px',
      autoFocus: false,
      data: {
        partner: this.model.partner,
        account: this.model.account
      },
    });
  }

  openEdit() {
    this.dialog.open(FlowConfirmEditModal, {
      width: '700px',
      autoFocus: false,
      data: {
        partner: this.model.partner,
        account: this.model.account,
        snapshot_id: this.model.snapshot_id,
        selector_test_id: this.model.selector_test.id,
        flow_id: this.model.flow_id,
        version: this.model.version,
      }
    }).afterClosed().subscribe((response) => {

      if (this.previousUrl) {

        if (response) {

          this.router.navigate([this.model.partner, this.model.account, 'snapshot', response.selector_id,
            'flow',
          response.selector_test_id,
          response.flow_id,
          response.version,
          response.order_id,
          this.model.period.start.format('YYYY-MM-DD'),
          this.model.period.end.format('YYYY-MM-DD'),
          response.order_id]);
        }
      }

    });

  }

  openValidate() {

    this.validateAllFormFields(this.form);
    let error = this.returnMsgErrorPublish();

    let flow_id, version;

    if (this.model.is_ab) {
      flow_id = this.model.selector_test.selector_test_flows[2].flow_id;
      version = this.model.selector_test.selector_test_flows[2].version;
    } else {
      flow_id = this.model.flow_id;
      version = this.model.version;
    }

    if (!error) {

      var dialogValidade = this.dialog.open(FlowValidatingModalComponent, {
        width: '700px',
        autoFocus: false,
        data: {
          partner: this.model.partner,
          account: this.model.account,
          flow_id: flow_id,
          version: version
        }
      });

      this.saveValidate(false).then(() => {

        var flows = [{ flow_id: flow_id, version: version }];

        setTimeout(() => {
          this.flowsService.compile({ flows }, this.model.partner, this.model.account, false)
            .subscribe((response) => {
              dialogValidade.close();

              if (response.flows[0].success) {

                this.dialog.open(FlowValidateModalComponent, {
                  width: '700px',
                  autoFocus: false,
                  data: {
                    partner: this.model.partner,
                    account: this.model.account,
                    flow_id: flow_id,
                    version: version
                  },
                });

              } else {
                this.toastr.error(response.flows[0].message);
                dialogValidade.close();

              }
            });
        }, 1000);

      });
    } else {
      this.toastr.error(this.translate.instant(error));
    }
  }

  async publish() {

    await this.saveValidate();

    this.validateAllFormFields(this.form);

    let error = this.returnMsgErrorPublish();

    if (!error) {

      this.flowsService.publish(this.model.partner, this.model.account,
        {
          flow_id: this.model.flow_version.flow.flow_id,
          version: this.model.flow_version.version,
          flow_name: this.model.flow_version.name,
          production: environment.production,

        }).subscribe(response => {
          this.toastr.success(this.translate.instant('flows.detail.published.success'));
          this.router.navigate([this.model.partner, this.model.account, 'flows']);

          this.openPublishFlowBetaModal();
        },
          (error) => {
            if (error.result.length > 0) {
              error.result.forEach(element => {
                this.toastr.error(element.message);
              });
            }
          });
    } else {
      this.toastr.error(this.translate.instant(error))
    }
  }

  redirectServices() {
    this.router.navigate([this.model.partner, this.model.account, 'services', 'antifraud']);
  }


  changeName() {

    const dialog = this.dialog.open(FlowChangeNameModalComponent, {
      width: '990px !important',
      data: {
        partner: this.model.partner, account: this.model.account,
        name: this.model.selector_test.selector_test_flows[0].name,
        description: this.model.selector_test.selector_test_flows[0].description,
        snapshot_id: this.model.snapshot_id,
        selector_test_id: this.model.selector_test_id,
        flow_id: this.model.flow_id,
        order: this.model.order,
        flow_version: this.model.flow_version,
      },
      autoFocus: true,
    });

    dialog.afterClosed().subscribe((response) => {

      if (response) {

        this.router.navigate([this.model.partner, this.model.account, 'snapshot', this.model.snapshot_id, 'flow', this.model.selector_test.id, this.model.flow_id, this.model.version, this.model.order, this.model.period.start.format('YYYY-MM-DD'),
        this.model.period.end.format('YYYY-MM-DD'),
        this.model.orders]).then(() => {
          window.location.reload();
        });;
      }
    })
  }

  openCreateAb() {
    if (this.model) {

      const dialog = this.dialog.open(CreateAbTestComponent, {
        width: '990px !important',
        autoFocus: true,
        data: {
          selector_test: this.model.selector_test,
          snapshot_id: this.model.snapshot_id,
          partner: this.model.partner,
          account: this.model.account,
          flow_version: this.model.flow_version,
          is_ab: this.model.ab != 'normal',
          action: this.model.selector_test.selector_test_flows.length > 1 ? 'manage' : 'create',
          canCancelTestAB: this.model.canCancelTestAB
        }
      });


      dialog.afterClosed().subscribe((result) => {

        if (result?.reload) {
          window.location.reload();
          this.router.navigate([this.model.partner, this.model.account, 'snapshot', this.model.snapshot_id, 'flow', this.model.selector_test.id, this.model.flow_id, this.model.version, this.model.order, this.model.period.start.format('YYYY-MM-DD'),
          this.model.period.end.format('YYYY-MM-DD'),
          this.model.orders]);
        }
      });

    }
  }

  private createService3ds(
    key: string,
    actions: Array<{ type: string; varName: string; constValue: string }>,
    service: any,
    nameAction: string,
    nameResult: string
  ): any {
    return {
      key,
      actions: actions.map(action => ({
        action: { type: action.type },
        filters: {
          name: this.translateService.instant('flows.detail.action_name'),
          expression: {
            nary_expr: {
              symbol: "&&",
              expression_list: [
                {
                  binary_expr: {
                    left: { var_expr: { var_name: action.varName, tuna_type: "ThreeDS" } },
                    right: { const_expr: { const: action.constValue } },
                    symbol: "is equal to",
                  },
                },
              ],
            },
          },
        },
      })),
      custom_data: { type: 'action', name: `${nameAction} ${service.custom_name} ${nameResult}` },
      name: nameAction,
      type: "action",
      services: [
        {
          id: service.service_id,
          service_name: service.service_name,
          version: service.version_id,
          variables: this.getServiceVariables(service.service_name),
        },
      ],
    };
  }

  private getServiceVariables(serviceName: string): any[] {
    const normalizedServiceName = serviceName.toLowerCase().trim().normalize("NFD").replace(/\s/g, '_');
    return (
      this.model.filter_3ds.find((p) => p.service.toLowerCase().trim() === normalizedServiceName)?.variables || []
    );
  }
}

interface DOMTabList {
  left: number;
  width: number;
}
